module.exports = __webpack_public_path__ + "static/media/icon-cancelado.a43063a3.svg";